import { h, Fragment } from 'preact';
import { usd } from '../utils/currency-old';

const ShopCta = ({ price, originalPrice, addToCart, noDecimals, ctaCopy="Add To Cart - " }) => {
  return (
    <button class='shop-cta proxima-nova uppercase' onClick={addToCart}>
      {ctaCopy}
      {price !== originalPrice && (
        <>
          <s class='shop-cta__cross-out'>
            {usd(originalPrice, noDecimals)}
          </s>{' '}
        </>
      )}
      {usd(price, noDecimals)}
    </button>
  );
};

export default ShopCta;
